// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"App_mainWrapper__17-FR","modal":"App_modal__1SKQe"};